import { zodResolver } from "@hookform/resolvers/zod";
import { Loader2 } from "lucide-react";
import { useForm } from "react-hook-form";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import {
  type AttendantFormDto,
  createAttendantDtoSchema,
} from "slde-api/dto-schemas";

interface AttendantFormProps {
  defaultValues?: AttendantFormDto;
  onSubmit: (values: AttendantFormDto) => void;
  disabled?: boolean;
  loading?: boolean;
}

export function AttendantForm({
  onSubmit: onSubmitProps,
  defaultValues,
  disabled,
  loading,
}: AttendantFormProps) {
  const form = useForm<AttendantFormDto>({
    resolver: zodResolver(createAttendantDtoSchema),
    defaultValues: defaultValues ?? {},
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmitProps)}
        className="space-y-4"
      >
        <FormField
          control={form.control}
          name="fullName"
          render={({ field: { value, ...field } }) => (
            <FormItem>
              <FormLabel>Imię i nazwisko</FormLabel>
              <FormControl>
                <Input value={value ?? ""} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="pin"
          render={({ field: { value, ...field } }) => (
            <FormItem>
              <FormLabel>PIN</FormLabel>
              <FormControl>
                <Input value={value ?? ""} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit" disabled={disabled || loading}>
          {!!defaultValues ? "Edytuj" : "Dodaj"}
          {loading && <Loader2 className="animate-spin" />}
        </Button>
      </form>
    </Form>
  );
}
